<template>
    <a-card :bordered="false">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery" :model="queryParam" >
          <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="this.language['cs.activity.activityname']"> 
             <a-input maxLength="50" allow-clear v-model="queryParam.activityname" :placeholder="this.language['cs.activity.activityname']"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="this.language['cs.activity.activitycode']">
             <a-input v-model="queryParam.activitycode" maxLength="50" :placeholder="this.language['cs.activity.activitycode']"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="this.language['cs.venue.venuename']">
             <a-input v-model="queryParam.venuenames" maxLength="50" :placeholder="this.language['cs.venue.venuename']"></a-input>
            </a-form-item>
          </a-col> </a-row>  <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="this.language['cs.activity.startenddate']">
              <a-date-picker  :placeholder="language['common.chooseStartDate']" format="YYYY-MM-DD" value-format="YYYY-MM-DD"  class="query-group-cust" v-model="queryParam.startdate"></a-date-picker>
                <span class="query-group-split-cust"></span>
                <a-date-picker  :placeholder="language['common.chooseEndDate']" format="YYYY-MM-DD" value-format="YYYY-MM-DD"  class="query-group-cust" v-model="queryParam.enddate"></a-date-picker>
       
            </a-form-item>
          </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">{{this.language['common.searchButton']}}</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{this.language['common.resetButton']}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 查询区域-END -->
      
      <!-- 操作按钮区域 -->
      <div class="table-operator">
        <a-button @click="handleAdd" type="primary" icon="plus"  v-has="'activity:add'">新增</a-button>
        <!-- 高级查询区域 -->
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="batchDel" v-has="'activity:deletebatch'"><a-icon type="delete"/>删除</a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
        </a-dropdown>
      </div>
  
      <!-- table区域-begin -->
      <div>
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
          <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        </div>
  
        <a-table
          ref="table"
          size="middle"
          bordered
          rowKey="sysactivityid"
          class="j-table-force-nowrap"
          :scroll="{x:1800}"
          :dataSource="dataSource"
          :pagination="ipagination"
          :columns="columns"
          :loading="loading"
          :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
          @change="handleTableChange">
          <template slot="htmlSlot" slot-scope="text">
            <div v-html="text"></div>
          </template>
          <span slot="action" slot-scope="text, record">
            <!-- <a @click="handleEdit(record)" v-has="'activity:edit'">{{language['common.edit']}}</a>
            <a-divider type="vertical" /> -->
            <a @click="handleAssign(record)" v-has="'activity:view'">{{language['common.edit']}}</a>
            <a-divider type="vertical" />
            <a-dropdown>
              <a class="ant-dropdown-link">{{language['common.more']}} <a-icon type="down" /></a>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a @click="handleDetail(record)" v-has="'activity:view'">{{language['common.look']}}</a>
                </a-menu-item>
                <a-menu-item v-has="'activity:delete'">
                  <a-popconfirm :title="language['common.deleteConfirmInfo']" @confirm="() => handleDelete(record.sysactivityid)">
                    <a>{{language['common.delete']}}</a>
                  </a-popconfirm>
                </a-menu-item>
                <!-- <a-menu-item>
                  <a @click="handleMsg(record)" v-has="'activity:view'">二維碼</a>
                </a-menu-item>
                <a-menu-item>
                  <a @click="handleMsg(record)" v-has="'activity:view'">座位分組</a>
                </a-menu-item> -->
              </a-menu>
            </a-dropdown>
          </span>
        </a-table>
      </div>
 
      <activity-modal ref="modalForm" @ok="modalFormOk"></activity-modal>
      <j-modal ref="ActivitySetting"
            :title="titleSetSeat"
            width="100%" 
            :visible="seatvisible"
            switchFullscreen
            @ok="handleSeatOk"
            :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
            @cancel="handleSeatCancel"
            cancelText="关闭">
    <template >
   <activity-setting ></activity-setting>
    </template>
      </j-modal>
    </a-card>
  </template>
  
  <script>
    import { httpAction, getAction } from '@/api/manageChooseSeat'
    import '@/assets/less/TableExpand.less'
    import { JeecgListMixin } from '@/views/chooseSeat/mixins/JeecgListMixin.js'
    import { getDictItemsFromCache  } from '@/api/api'
    import ActivityModal from './modules/ActivityModal'   
    import ActivitySetting from './modules/ActivitySetting'
    

    export default {
      name: "Activity",
      mixins:[JeecgListMixin],
      components: {
        ActivityModal,
        ActivitySetting
      },
      data () {
        return {
          description: '活動信息',
          seatvisible:false,
          viewseatvisible:false,
          titleSetSeat:"",
          // 表头
         
          url: {
            list: "/ActivityInfo/list",
            delete: "/ActivityInfo/delete",
            deleteBatch: "/ActivityInfo/deleteBatch"
            
          },
          operation :{
           titleSetSeat:"add",
           sysactivityid:"",
           sysvenueid:"",   
            visible: true,
            optiontype:"add",   
           }, 
           dataActivity :{
            sysactivityid:"",
            sysvenueid:"",   
            isShow:true  
           }, 
        }
      },
      created() {
      }, 
       provide(){
        return{
         operation:this.operation,
         dataActivity:this.dataActivity
        }
       },
      mounted(){
      
      },
      computed: {
        language() {
          return this.$store.getters.language
        },
        columns() {
          if (this.language) {
            return  [
            {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
              title:this.language['cs.activity.activitycode'],
              align:"center",
              width:150,
              ellipsis: true,
              dataIndex: 'activitycode'
            },
            {
              title:this.language['cs.activity.activityname'],
              align:"left",
              width:150,
              ellipsis: true,
              dataIndex: 'activityname'
            },
            {
              title:this.language['cs.venue.venuename'],
              align:"left",
              width:150,
              ellipsis: true,
              dataIndex: 'venuenames'
            }, 
            {
              title:this.language['cs.activity.startdate'],
              align:"center",
              width:150,
              ellipsis: true,
              dataIndex: 'startdate'
            },
            {
              title:this.language['cs.activity.enddate'],
              align:"center",
              width:150,
              ellipsis: true,
              dataIndex: 'enddate'
            },
            {
              title:this.language['cs.activity.seatstartdate'],
              align:"center",
              width:150,
              ellipsis: true,
              dataIndex: 'seatstartdate'
            },
            {
              title:this.language['cs.activity.seatenddate'],
              align:"center",
              width:150,
              ellipsis: true,
              dataIndex: 'seatenddate'
            },
            {
              title:this.language['common.creator'],
              align:"center",
              width:150,
              dataIndex: 'creator'
            },  
            {
              title:this.language['common.createTime'],
              align:"center",
              width:150,
              dataIndex: 'createdate'
            },  
            {
              title:this.language['common.modifier'],
              align:"center",
              width:150,
              dataIndex: 'modifier'
            },  
            {
              title:this.language['common.modifyTime'],
              align:"center",
              width:150,
              dataIndex: 'modifydate'
            },  
            {
              title: '操作',
              dataIndex: 'action',
              align:"center",
              fixed:"right",
              width:200,
              scopedSlots: { customRender: 'action' },
            }
          ]
          }
        }
      },
      methods: {
        handleMsg(){
          alert("功能正在開發中！");
        },
        handleSeatOk()
        {  this.seatvisible=false;
          this.loadData(1);
        },
        handleSeatCancel()
        {  this.seatvisible=false; this.loadData(1);},
        searchQuery() {
        this.loadData(1);
        },
        handleEdit(record) {
            this.$refs.modalForm.edit(record);
            this.$refs.modalForm.title = "编辑";
            this.$refs.modalForm.disableSubmit = false;
            this.operation.optiontype="edit"; 
            this.operation.activityinfo=record ;
            this.operation.visible=true;
          },
          handleDetail(record){
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title="详情";
      this.$refs.modalForm.disableSubmit = true;
            this.operation.optiontype="view"; 
            this.operation.activityinfo=record ;
            this.operation.visible=true;
    },
         handleAdd () {
            this.$refs.modalForm.add();
            this.$refs.modalForm.title = "新增";
            this.$refs.modalForm.disableSubmit = false;
            this.operation.optiontype="add";
            this.operation.visible=false;
         },
        handleAssign(record)
        {
          this.titleSetSeat= record.activityname ;
          this.operation.titleSetSeat=record.activityname +"-"+record.venuenames  ;
          this.operation.sysactivityid=record.sysactivityid ;
          this.operation.sysvenueid=record.sysvenueidlist[0] ;
          this.operation.activityinfo=record ;
          this.operation.optiontype="edit"; 
          this.operation.visible=true;
          this.dataActivity.isShow=false;
          this.dataActivity.sysactivityid=record.sysactivityid ;
          this.dataActivity.sysvenueid=record.sysvenueidlist[0] ;
          this.seatvisible=true;
        }
      }
    }
  </script>
  <style scoped>
    /* @import '~@assets/less/common.less'; */

  </style>